import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSButton from "../../Components/Button/WSButton";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
// import BannerImage from '../../../FrontEnd/Images/Banner/1.jpg'

import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import httpDash from "../../commonFunctions/htttpClientNew";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSDateField from "../../Components/DateField/WSDateField";
import { Header } from "../../Components/Header/Header";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSSelectDashboard from "../../Components/Select/WSSelectDashboard";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSAutoCompleteDashBoard from "../../Components/AutoComplete/WSAutoCompleteDashBoard";
export const Bill: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const id = params?.id;
  const [category, setCategory] = useState<string>("");
  const [startDate, setStartDate] = useState<string>();
  const [isChequeIssued, setIsChequeIssued] = useState(false)
  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getPromotionById(id: any) {
      try {
        const response: any = await httpDash.get(`Bill/${id}`);
        
        if (response) {
          setValue("invoiceNo", response?.invoiceNo);
          setValue("supplierId", response?.supplierId);
          setValue(
            "invDate",
            dayjs(response?.invoiceDate).format("DD/MM/YYYY")
          );
          setValue("dueDate", dayjs(response?.dueDate).format("DD/MM/YYYY"));
          setValue("amount", response?.amount);
          setValue("isCheckIssued", response?.chequeIssued);
          setValue("isHold", response?.isHold);
          setValue("chequeNumber", response?.chequeNumber);

          setValue("id", response?.id);
          setCategory(response?.category);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getPromotionById(id);
    }
  }, [id]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      const invDate = dayjs(data.invDate, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      );
      const dueDate = dayjs(data.dueDate, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS"
      );
      let request = {
        supplierId: data?.supplierId,
        invoiceNo: data.invoiceNo,
        category: category,
        invDate: invDate,
        dueDate: dueDate,
        amount: data.amount,
        chequeIssued: data.isCheckIssued,
        isHold: data?.isHold,
        chequeNumber: data?.chequeNumber

      };

      // const newRequest = clearRequest(request)
      if (id) {
        const response: any = await httpDash.put(`Bill/${id}`, request);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          if (response?.success === true) {
            navigate("/bill/list");
          }
        }
      } else {
        const response: any = await httpDash.post(`Bill`, request);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          if (response?.success === true) {
            // navigate('/bill/list')
            reset();
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };

  const handleCancelClick = () => {
    navigate("/bill/list");
  };

  const source = {
    url: "Supplier/search",
    page: 1,
    pageSize: 10000,
    filter: [],
    sort: []
  };
  const transFormData = (data: any) => {
    let supplierList: Array<any> = [];
    data &&
      data?.map((item: any) => {
        supplierList.push({ label: `${item?.name}`, value: item.id });
      });
    return supplierList;
  };
  const handleSupplierChange = async (evt: any) => {
    const supid = evt?.value;
    try {
      if (supid) {
        const response: any = await httpDash.get(`Supplier/${supid}`);
        if (response?.data) {
          setCategory(response?.data?.category);
          setValue("invDate", null);
          setValue("dueDate", null);
        }
      }
    } catch (e) { }
  };
  const startDateChanged = (event: any) => {
    const categoryValues: Record<string, number> = {
      A: 7,
      A1: 10,
      B: 15,
      B1: 21,
      C: 30,
      C1: 45,
      D: 60
    };

    const cat = categoryValues[category] ?? 30; // Default to 30 if not found
    let dueDate = dayjs(convertToDate(event)).add(cat, "day");

    // Keep adjusting the due date until it is not Sunday and not 3rd/4th/5th
    while (
      dueDate.day() === 0 || // 0 = Sunday
      [3, 4, 5].includes(dueDate.date())
    ) {
      dueDate = dueDate.add(1, "day");
    }

    setStartDate(dueDate.format("DD/MM/YYYY"));
  };
  const handleChequeIssuedChnage = (evt: any) => {
    setIsChequeIssued(evt?.target?.checked)
  }
  const convertToDate = (dateString: string) => {
    // Parse the date string using the custom format
    const date = dayjs(dateString, "DD/MM/YYYY");

    if (date.isValid()) {
      return date; // Returns a dayjs object
    } else {
      console.error("Invalid date format");
      return null;
    }
  };
  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title={`${id ? "Edit" : "Add"} Bill`}
        url="/bill/list"
        id={"promotionImg"}
        isBackButton={true}
        headerSx={{ marginTop: 0 }}
      />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3
          }}
        >
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSAutoCompleteDashBoard
                label={"Supplier"}
                {...register("supplierId")}
                onChange={handleSupplierChange}
                id="supplierId"
                name="supplierId"
                control={control}
                transFormData={transFormData}
                source={source}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Invoice No"}
                {...register("invoiceNo")}
                id="invoiceNo"
                name="invoiceNo"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSDateField
                id="invDate"
                name="invDate"
                label={"Invoice Date"}
                dateFormat="DD/MM/YYYY"
                onChange={startDateChanged}
                control={control}
                setValue={setValue}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="dueDate"
                name="dueDate"
                label={"Due Date"}
                dateFormat="DD/MM/YYYY"
                control={control}
                defaultValue={startDate}
                disabled={true}
                setValue={setValue}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Amount"}
                {...register("amount")}
                id="amount"
                name="amount"
                type={TextType.Currency}
                currency={CurrencyType.Rupee}
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <WSSCheckBoxField
                control={control}
                id={`isCheckIssued`}
                defaultValue={false}
                name={`isCheckIssued`}
                rules={{ required: false }}
                onChange={handleChequeIssuedChnage}
                label="Is Check Issued"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <WSSCheckBoxField
                control={control}
                id={`isHold`}
                defaultValue={false}
                name={`isHold`}
                rules={{ required: false }}
                label="Is Hold"
              />
            </Grid>
            {isChequeIssued && <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Cheque Number"}
                id="chequeNumber"
                name="chequeNumber"
                control={control}
                rules={{ required: false }}
              />
            </Grid>}

            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField name="id" control={control} />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                onClick={handleCancelClick}
                size="medium"
                className="ws-cancel"
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
});
